var map = {
	"./ai.jpg": 2920,
	"./casualGames.jpg": 3420,
	"./finance.jpg": 8362,
	"./shortPlays.jpg": 9481,
	"./social.jpg": 1215,
	"./tools.jpg": 9725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5269;